import React from "react";

export default function Map({ lat = 19.093454, lng = 72.82809, height = 400 }) {
  const src = `https://www.google.com/maps?q=${lat},${lng}&z=15&output=embed`;

  return (
    <div style={{ position: "relative", width: "100%", height }}>
      <iframe
        title="Map Location"
        src={src}
        style={{ border: 0, width: "100%", height: "100%" }}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
      />
    </div>
  );
}